import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ListFilter = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        className='lucide lucide-list-filter-icon lucide-list-filter'
      >
        <path d='M3 6h18' />
        <path d='M7 12h10' />
        <path d='M10 18h4' />
      </svg>
    </SvgIcon>
  );
};

export default ListFilter;
